import { type User, useAuth } from '@app/libs/auth';
import type { ReactElement, ReactNode } from 'react';

//#region : Main component

/** Custom. Main component parameters type */
export type AuthViewProps = {
    unauthorizedComponent?: ReactElement | ((user?: User | null) => ReactElement);
    checkPermission?: (user: User) => boolean;
    children?: ReactNode;
};

/**
 * Custom helper component.
 *
 * Use it when you want to show component's children only when user is logged in and has permission
 */
const AuthorizationView = ({ children, unauthorizedComponent, checkPermission = () => true }: AuthViewProps) => {
    const { user } = useAuth();

    //User is not logged in or does not have sufficient permissions
    if (!user || !checkPermission(user)) {
        //If unauthroized component is provided return that
        if (unauthorizedComponent) {
            return typeof unauthorizedComponent === 'function' ? unauthorizedComponent(user) : unauthorizedComponent;
        }

        //otherwise return null
        return null;
    }

    //All clear. Return children.
    return <>{children}</>;
};

export default AuthorizationView;
//#endregion : Main component
